import { render, staticRenderFns } from "./SubmissionBar.vue?vue&type=template&id=79103b98&scoped=true&"
import script from "./SubmissionBar.vue?vue&type=script&lang=js&"
export * from "./SubmissionBar.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionBar.vue?vue&type=style&index=0&id=79103b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79103b98",
  null
  
)

export default component.exports